import * as angular from 'angular';
import { react2angular } from 'react2angular';
import permissions from 'application/detail/permissions.json';
import { UsersController } from './UsersController';
import { UserDetailController } from 'modules/application/detail/users/detail/UserDetailController';
import { UsersService } from './UsersService';
import { UsersSegmentService } from './UsersSegmentService';
import UsersView from './UsersView.html';
import UserDetailView from './detail/UserDetailView.html';
import UsersViewReact from './usersViewComponent/UsersViewReact';
import TranslateService from 'modules/translate/TranslateService';
export const userStateName = 'auth.application.detail.users';
export const userDetailStateName = 'auth.application.detail.users.user';
export default angular
    .module('users', [])
    .service('UsersService', UsersService)
    .service('UsersSegmentService', UsersSegmentService)
    .service('TranslateService', TranslateService)
    .component('usersViewReact', react2angular(UsersViewReact, ['users'], [
    'UsersService',
    'UsersSegmentService',
    'TranslateService',
    '$state',
]))
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state(userStateName, {
            url: '/users?userIdentity',
            views: {
                'content@auth.application.detail': {
                    template: UsersView,
                    controller: UsersController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.users.claim,
            },
            params: { area: 'users' },
        })
            .state(userDetailStateName, {
            url: '/:id?ticketId',
            views: {
                'content@auth.application.detail': {
                    template: UserDetailView,
                    controller: UserDetailController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.users.claim,
            },
            params: { area: 'users' },
        });
    }]).name;
